(function() {

  let attachments = {}

  attachments.handleTrixUpload = function(event) {
    var upload_url = $(event.target).attr('upload-url')
    if (event.attachment.file) {
      const params = {
        name: event.attachment.file.name,
        type: event.attachment.file.type
      }
      fetch(_.appendQueryArgs(upload_url, params))
        .then(response => response.json()
          .then(formobj => uploadFileAttachment(event.attachment, formobj)))
    }
  }

  attachments.handleSummerUpload = function(files, $summernote) {
    var uploadUrl = "/sites/direct-form/rpdotcom/image"
    for (let i = 0; i < files.length; i += 1) {
      file = files[i]
      const params = {
        name: file.name,
        type: file.type
      }
      fetch(_.appendQueryArgs(uploadUrl, params))
        .then(response => response.json()
          .then(formobj => completeSummerUpload($summernote, file, formobj)))
    }
  }

  function completeSummerUpload($sn, file, formobj) {
    function setProgress(progress) {
      console.log(progress)
    }
    function setAttributes(attributes) {
      $sn.summernote('insertImage', attributes.url)
    }
    uploadFile(file, formobj, setProgress, setAttributes)
  }

  function errorCb (msg) {
    _.alert(msg, 'danger')
  }

  function uploadFileAttachment(attachment, formobj) {

    function setProgress(progress) {
      console.log(progress)
      attachment.setUploadProgress(progress)
    }

    function setAttributes(attributes) {
      attachment.setAttributes(attributes)
    }

    uploadFile(attachment.file, formobj, setProgress, setAttributes)
  }

  function uploadFile(file, formobj, progressCb, successCb) {
    var formData = createFormData(formobj.fields, file)
    var xhr = new XMLHttpRequest()

    xhr.open("POST", formobj.url, true)

    xhr.upload.addEventListener("progress", function(event) {
      var progress = event.loaded / event.total * 100
      progressCb(progress)
    })

    xhr.addEventListener("load", function(event) {
      var download_url, attributes

      if (xhr.status == 204) {
        // proxy_url must be provided by the server
        if (!formobj.proxy_url) {
          errorCb("Server error: proxy_url not provided in upload response")
          return
        }
        download_url = formobj.proxy_url
      } else {
        errorCb(`File upload failed with status code: ${xhr.status}`)
      }
      attributes = {
        url: download_url,
        href: download_url,
        name: false,
        size: false
      }
      successCb(attributes)
    })

    xhr.addEventListener("error", function(event) {
      errorCb("File upload network error.")
    })

    xhr.send(formData)
  }

  function createFormData(fields, file) {
    var data = new FormData()
    for (const [key, value] of Object.entries(fields)) {
      data.append(key, value)
    }
    data.append("file", file)
    return data
  }

  window.attachments = attachments

})();
